import logger from 'OK/logger';
import { traverseParents } from 'OK/utils/dom';
import { EVENT_TRIGGERED, EVENT_TYPE } from 'OK/LogListenerEventBuses';

var
    /** @type {string} */
    MARKER = 'data-l',
    MARKER_OLD = 'data-log-click', //Оставлен временно, на случай если где-то что-то не досмотренно.
    LOG_ATTR_SELECTOR = '[' + MARKER + '],[' + MARKER_OLD + ']',
    FORCE_PUSH_MARKER = 'data-force',
    /** @type {string} */
    SUCCESS = 'click',
    /** @type {string} */
    ERROR = 'log.click',
    /** @type PerformanceNavigationTiming */
    navigation,
    /** @type {?number} */
    from = null;

/**
 * @param {Object[]} result
 * @param {Object} json
 * @param {Event} event
 */
function pushIfNotEmpty(result, json, event) {
    if (json && Object.keys(json).length) {
        result.push(json);
        if (json.target && !event.okTarget) {
            /* Запоминаем первый пойманный таргет */
            event.okTarget = json.target;
        }
    }
}

/**
 * Log operation and parameter to console and server log.
 */
function logSuccess(param1) {
    OK.logging.info(SUCCESS + ' ' + param1);
    logger.success(SUCCESS, param1);
}

function logSuccessForce(param1) {
    OK.logging.info(SUCCESS + ' ' + param1);
    logger.force(SUCCESS, param1);
}

/**
 * Log error and parameter to console and server log.
 */
function logError(message) {
    OK.logging.alert(ERROR + ' ' + message);
    logger.error(ERROR, message);
}

function getDataAttr(elem) {
    if (!elem) {
        return null;
    }

    var attrVal = elem.getAttribute(MARKER);
    if (!attrVal) {
        attrVal = elem.getAttribute(MARKER_OLD);
    }

    return attrVal;
}

//см. one.app.community.dk.click.LogJsonSupplier

var aliases = {
    "t": "target",
    "ti": "targetId",

    "mB": "mtBlockType",
    "gA": "groupActionType",
    "fF": "feedFeatures",
    "fP": "feedPosition",
    "fL": "feedLocation",
    "fD": "feedDetails",
    "fO": "feedOwners",
    "fI": "feedId",

    ".r": "remove",
    "rM": "removeMenu",
    ".c": "content",

    ".k": "comment",
    "re": "reshare",
    ".l": "like",

    "e1": "entity1",
    "e2": "entity2",
    "cl": "click",
    "uL": "userLink",
    "gL": "groupLink",

    ".a": "action"
};

function getData(data) {
    var step = -2;
    try {
        if (!data || data.length == 0 || /^{|^null&/i.test(data)) {
            step = -1;
            return JSON.parse(data); //null -> null
        }

        step = 0;

        var result = {};

        var escapeNow = false;
        var keyNow = true;

        var key = "";
        var value = "";
        var alias = ""; // в целях оптимизации трафика часть читаемых аттрибутов меняется на иероглифы.

        var l = data.length;

        //будем откусывать от data по фрагменту без спец символов, чтобы не добавлять по одному символу в строку постоянно.
        var start = 0;
        var length = 0;

        for (var i = 0; i < l; i++) {
            step = 1;
            var c = data.charAt(i);
            if (escapeNow) {
                //конец эскейпа - добавляем текущий символ в строку.
                escapeNow = false;
                length++;
            } else if (c == '\\') {

                if (length > 0) {
                    //надо скинуть уже прочитанные данные
                    if (keyNow) {
                        step = 2;
                        key += data.substr(start, length);
                    } else {
                        step = 3;
                        value += data.substr(start, length);
                    }
                    length = 0;
                }
                start = i + 1; //чтение продожится со след символа...

                //начало эскейпа
                escapeNow = true;

            } else if (c == ',') {
                //разделитель в последовательности: ключ,значение,ключ,значение

                if (keyNow) {

                    if (length > 0) {
                        //надо скинуть уже прочитанные данные
                        step = 4;
                        key += data.substr(start, length);
                        length = 0;
                    }

                    //ключ кончился => начинаем читать значение
                    keyNow = false;
                } else {

                    if (length > 0) {
                        //надо скинуть уже прочитанные данные
                        step = 5;
                        value += data.substr(start, length);
                        length = 0;
                    }

                    //значение кончилось => начинаем читать ключ и нужно сохранить рез-т.
                    keyNow = true;

                    alias = aliases[key];
                    if (alias) {
                        key = alias;
                    }
                    alias = aliases[value];
                    if (alias) {
                        value = alias;
                    }

                    result[key] = value;

                    key = "";
                    value = "";
                }
                start = i + 1; //продолжать чтение будем после ",".


            } else {
                //обычный символ - просто добавляем в строку.
                length++;
            }
        }

        step = 6;

        if (escapeNow) {
            logError("err: escapeNow - " + data);
        } else if (keyNow) {
            if (start != l) {
                //перед выходом из цикла читали ключ..., а должны были значение.
                logError("err: keyNow - " + data);
            }
            // else {
            //   перед выходом из цикла прочитали запятую сразу после последней пары ключ,значение
            //   простим такое.
            // }
        } else {


            //перед выходом из цикла читали значение...

            if (start < l) {
                //...и не дочитали, то дочитываем:
                step = 7;
                value += data.substr(start);
            }

            alias = aliases[key];
            if (alias) {
                key = alias;
            }
            alias = aliases[value];
            if (alias) {
                value = alias;
            }

            //сохраняем рез-т:
            result[key] = value;
        }

        return result;
    } catch(e) {
        logError("unkn err: stepN = " + step + ", data = " + data + ", e = " + e);
        return {};
    }
}

/**
 * @typedef PerformanceServerTiming
 * @property description {string}
 * @property duration {number}
 * @property name {string}
 */

function parseServerTiming() {
    from = 0; /* На случай неудачи */
    try {
        /* Получим серверный таймштамп */
        var
            /** @type PerformanceEntryList */
            navigationEntries = performance.getEntriesByType('navigation'),
            /** @type PerformanceServerTiming[] */
            serverTiming,
            /** @type number */
            idx;
        if (navigationEntries && navigationEntries.length) {
            navigation = navigationEntries[0];
            serverTiming = navigation.serverTiming;
        }
        if (serverTiming && serverTiming.length) {
            for (idx = 0; idx < serverTiming.length; idx += 1) {
                if (serverTiming[idx].name === 'from') {
                    from = serverTiming[idx].duration;
                    break;
                }
            }
        }
    } catch (e) {
        from = 0;
    }
}

function appendServerTime(result) {
    if (from == null) {
        parseServerTiming();
    }
    if (from > 0) {
        try {
            /*
             * N.B.
             * Этот код считает, что у нас нулевая задержка между генерацией заголовка на сервере
             * и получением первого байта ответа в браузере.
             * В реальности это не так, все события происходят несколько позже, чем мы высчитываем
             */
            var adjustedTime = Math.round(performance.now() - navigation.responseStart + from);
            result.push({
                'adjustedTime': adjustedTime
            })
        } catch (ignore) {
        }
    }
}

/**
 * Listener for click event anywhere inside hook element.
 * It collects all given attribute values into array and then logs them.
 *
 * @param {Event} event
 */
function listener(event) {
    var
        /** @type {string} */
        attrVal,
        /** @type {boolean} */
        forceLogPush = false,
        /** @type {Object[]} */
        result = [];
    try {
        // looking for attribute in current element
        attrVal = getDataAttr(event.target);
        if (attrVal) {
            pushIfNotEmpty(result, getData(attrVal), event);
        }
        // looking for attribute in all parents until body
        var elem = event.target.parentElement;
        while (elem) {
            if (elem.matches(LOG_ATTR_SELECTOR)) {
                attrVal = getDataAttr(elem);
                if (attrVal) {
                    pushIfNotEmpty(result, getData(attrVal), event);
                }
            }
            if (elem.hasAttribute(FORCE_PUSH_MARKER)) {
                forceLogPush = true;
            }
            elem = elem.parentElement;
        }
        if (result.length) {
            /* result is not empty */
            appendServerTime(result);

            var serializedPayload = JSON.stringify(result);
            if (forceLogPush) {
                logSuccessForce(serializedPayload);
            } else {
                logSuccess(serializedPayload);
            }

            EVENT_TRIGGERED.emit({
                type: EVENT_TYPE.CLICK,
                payload: serializedPayload
            }, this);

        }
    } catch (ex) {
        logError(ex);
    }
}

/**
 * @param {HTMLElement} element
 */
function activate(element) {
    /* Будем использовать фазу capture, для всех окромя динозавра IE-8 */
    element.addEventListener('click', listener, true);
    OK.clickLog.incCounter();
}

/**
 * @param {HTMLElement} element
 */
function deactivate(element) {
    element.removeEventListener('click', listener, true);
    OK.clickLog.decCounter();
}

function getLogData(from) {
    var logDataAsString = getDataAttr(from);
    if (logDataAsString) {
        return getData(logDataAsString);
    }
}

function updateLogData(container, logData) {
    var attrToUse = MARKER;
    if (container.getAttribute(MARKER_OLD)) {
        attrToUse = MARKER_OLD;
    }

    /* Пакуем обратно */
    var logDataAsString = JSON.stringify(logData);

    /* Обновляем ДОМ */
    container.setAttribute(attrToUse, logDataAsString);
}

function copyLogData(from, to) {
    var attrToUse = MARKER;
    if (from.getAttribute(MARKER_OLD)) {
        attrToUse = MARKER_OLD;
    }
    to.setAttribute(attrToUse, from.getAttribute(attrToUse));
}

function getClosestLogClickElement(elem) {
    if (elem.matches(LOG_ATTR_SELECTOR)) {
        return elem;
    } else {
        return traverseParents(elem, function (e) {
            return e.matches(LOG_ATTR_SELECTOR);
        });
    }
}

function doLogOnElement(element) {
    listener({
        'target': element
    });
}

export default { activate, deactivate, getLogDataAsString: getDataAttr, parseLogData: getData, getLogData, updateLogData, copyLogData, getClosestLogClickElement, doLogOnElement, LOG_ATTR_SELECTOR };

export { activate, deactivate, getDataAttr as getLogDataAsString, getData as parseLogData, getLogData, updateLogData, copyLogData, getClosestLogClickElement, doLogOnElement, LOG_ATTR_SELECTOR };
